import script from "./GestioneSlotVisite.vue?vue&type=script&setup=true&lang=js"
export * from "./GestioneSlotVisite.vue?vue&type=script&setup=true&lang=js"

import "./GestioneSlotVisite.vue?vue&type=style&index=0&id=13f32f63&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13f32f63"]])

export default __exports__